export const MAIN_OWNERS = ['Hassan Kashir', 'Rana Hasaan Aslam', 'Ch Husnain Ali'];
export const OWNER_SHARE_PERCENT = 32;
export const CHARITY_SHARE_PERCENT = 4;
export const CHARITY_LABEL = 'In The Name Of Allah';

/** Old short names → current display names (URLs / sheet rows) */
export const LEGACY_OWNER_SLUGS = {
  hassan: 'Hassan Kashir',
  hasaan: 'Rana Hasaan Aslam',
  husnain: 'Ch Husnain Ali',
};

export const ownerSlug = (name) => name.toLowerCase().replace(/\s+/g, '-');

export const ownerFromSlug = (slug) =>
  LEGACY_OWNER_SLUGS[slug] ||
  MAIN_OWNERS.find((n) => ownerSlug(n) === slug) ||
  slug;

export const OWNER_AVATARS = {
  'Hassan Kashir': 'HK',
  'Rana Hasaan Aslam': 'RA',
  'Ch Husnain Ali': 'HA',
};

export const ORDER_STATUS_ROUTES = {
  Pending: '/orders/pending',
  Confirmed: '/orders/confirmed',
  Dispatched: '/orders/dispatched',
  Delivered: '/orders/delivered',
  Returned: '/orders/returned',
  Cancelled: '/orders/cancelled',
};

export const STATUS_WORKFLOW = {
  // Pending → Confirm → Confirmed → Dispatch (final step — no Deliver)
  Pending:              'Confirmed',
  Confirmed:            'Dispatched',
  Processing:           'Dispatched',   // legacy verified online rows
  Packed:               'Dispatched',   // legacy rows
  Dispatched:           null,
  // Pending Verification must go through verifyPayment — no advance button
  'Pending Verification': null,
  'Payment Failed':       null,
};
